export default __webpack_public_path__ + "static/media/rating-not-my-thing-outline.2624fafd.svg";